import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
import bloques from "./aniversario/bloques";
require('../sass/app.scss');
var ajustaVw = function () {
    document.documentElement.style.setProperty('--vw', "".concat(document.documentElement.clientWidth, "px"));
};
var dataLayer = window.dataLayer;
addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
bloques();
animadoAlAparecer('.animado');
formulario('form', {
    dataLayer: dataLayer,
    ocultarEtiquetas: true
});
